'use client';

import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ToastType, ToastContext } from '@/app/providers/ToastProvider';

export const useToast = () => {
  const { t } = useTranslation();
  const { setToast } = useContext(ToastContext);

  const showToast = (toast: ToastType) => {
    setToast(toast);

    setTimeout(() => {
      setToast(null);
    }, toast.timeout || 3000);
  };

  const showSuccessToast = (message: string, timeout?: number) => {
    showToast({ type: 'success', message, timeout });
  };

  const showWarningToast = (message: string, timeout?: number) => {
    showToast({ type: 'warning', message, timeout });
  };

  const showErrorToast = (message: string, timeout?: number) => {
    showToast({ type: 'error', message, timeout });
  };

  const showGenericErrorToast = () => {
    showToast({ type: 'error', message: t('hooks.useToast.defaultError') });
  };

  const showSaveSuccessToast = () => {
    showToast({ type: 'success', message: t('hooks.useToast.updated') });
  };

  return {
    showToast,
    showGenericErrorToast,
    showSaveSuccessToast,
    showSuccessToast,
    showWarningToast,
    showErrorToast,
  };
};
